import React from 'react';
import RankListDropdownCo from '@/pages/dashboard/components/RankListDropdownCo';
import './index.scss';
import SegmentScrollCo from '@/pages/dashboard/components/SegmentScrollCo';

interface SegmentConfig {
  componentSegment: {
    value: string;
    enName: string;
    cnName: string;
    disable: boolean;
    rainbowKey: string;
    enTooltip: string;
    cntooltip: string;
  }[];
  scrollMarginTop: string;
  dataKey: string;
}

interface ScrollBodyCoProps {
  data: any;
  changeData: (key: string, value: string) => void;
  children: any;
  className?: string;
  config: SegmentConfig;
  hasRight?: boolean;
  [key: string]: any;
}

const ScrollBodyCo: React.FC<ScrollBodyCoProps> = (props) => {
  const { data, changeData, config, hasRight = true } = props || {};
  const { dataKey } = config || {};

  return (
    <SegmentScrollCo
      rightSegment={
        hasRight && (
          <RankListDropdownCo
            data={data}
            changeData={changeData}
            dataKey={dataKey}
          />
        )
      }
      {...props}
    />
  );
};

export default ScrollBodyCo;